export const enum MyAccountListTypeEnum {
  contacted = 'CONTACTED',
  saved = 'SAVED',
  notes = 'NOTES',
  searches = 'SAVED_SEARCHES',
}
